import * as THREE from 'three';

/**
 * Utility class for raycasting operations
 */
export class RaycastHelper {
    constructor(camera, domElement) {
        this.camera = camera;
        this.domElement = domElement;
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();
    }

    /**
     * Get mouse coordinates in normalized device coordinates (-1 to +1)
     * @param {MouseEvent} event - Mouse event
     * @returns {THREE.Vector2}
     */
    getMouseCoordinates(event) {
        const rect = this.domElement.getBoundingClientRect();
        this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        return this.mouse;
    }

    /**
     * Perform raycast and get intersection point on objects
     * @param {MouseEvent} event - Mouse event
     * @param {THREE.Object3D|THREE.Object3D[]} objects - Object(s) to test intersection
     * @returns {THREE.Intersection|null}
     */
    raycast(event, objects) {
        this.getMouseCoordinates(event);
        this.raycaster.setFromCamera(this.mouse, this.camera);
        
        const objectsArray = Array.isArray(objects) ? objects : [objects];
        const intersects = this.raycaster.intersectObjects(objectsArray);
        
        return intersects.length > 0 ? intersects[0] : null;
    }

    /**
     * Perform raycast and get all intersections
     * @param {MouseEvent} event - Mouse event
     * @param {THREE.Object3D|THREE.Object3D[]} objects - Object(s) to test intersection
     * @returns {THREE.Intersection[]}
     */
    raycastAll(event, objects) {
        this.getMouseCoordinates(event);
        this.raycaster.setFromCamera(this.mouse, this.camera);
        
        const objectsArray = Array.isArray(objects) ? objects : [objects];
        return this.raycaster.intersectObjects(objectsArray);
    }
}

